module.exports = __webpack_public_path__ + "img/empty-bg.e55dcec1.png";